module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Foreword by Dennis Edwards")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("PART 1: AN ECCLESIOLOGY FOR JUSTICE")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("1 Justice Isn’t an Outreach Strategy"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("A Way of Life for the People of God")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Exiles in the Promised Land"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("The Church as Prophetic Alternative")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Demonstrating Mañana"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("The Church as a Parable of God’s Intent")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Gardeners of Shalom"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("The Church for Flourishing and Transformation")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2: JUSTICE IN OUR CONGREGATIONAL LIFE")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Low-Ground Church"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Discerning Vision in a High-Ground World")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Recovering Kinship"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Hospitality as Resistance")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Finding Common Kingdom Ground"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Discipling People into Shalom Community")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Worship"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Questions That Drive How We Gather")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3: WHAT’S NEXT?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Power"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("A Conversation About the Linchpin of Justice with Juliet Liu and Brandon Green")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Epilogue"), _c('br'), _c('i', [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Commence Justice")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Becoming a Just Church")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tabulation1"
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0